@if (userStore.initialized() && userStore.isLoggedIn()) {
  <app-authenticated-view></app-authenticated-view>
} @else if (!userStore.initialized()) {
  <app-data-backend-skeleton [size]="sidebarService.contentSize$()" />
}
<app-tool-overlay [class]="sidebarService.contentSize$()"></app-tool-overlay>
<app-help-dialog></app-help-dialog>
